<template>
  <div class="flex flex-col items-center text-center">
    <DacrBadge class="size-[82px] mb-5" :icon-size="56" />
    <div class="mb-5 text-[34px] leading-10 font-medium text-gray-800">
      View this private copyright
    </div>
    <div
      class="mb-[30px] max-w-[266px] text-[16px] leading-[24px] text-gray-500"
    >
      Sign in or create a Dacr account to access this copyright
    </div>
    <Button
      class="mb-[18px] w-full tablet-h:w-auto"
      variant="primary"
      size="lg"
      @click="handleCreateAccountClick"
    >
      Create an account
    </Button>
    <div class="text-[14px] leading-[22px] text-gray-800">
      Have an account?
      <span class="text-link" @click="handleSignInClick">Sign in</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Button } from '@dacr/library'

import DacrBadge from '@/shared/components/DacrBadge.vue'
import { useFromInvite } from './useFromInvite'

const props = defineProps<{
  email: string
}>()

const { handleCreateAccountClick, handleSignInClick } = useFromInvite(
  props.email
)
</script>
